/**
 * author: Patrick Vyn Badiang
 */
import { Box, Typography } from "@mui/material";
import { useDirection } from "../UtilityFunctions";
import AddToCalendarButton from "./AddToCalendarButton";

// Function to format date string "YYYYMMDD" to "Month Dayth"
const formatDate = (dateString) => {
  if (!/^(\d{8})$/.test(dateString)) return dateString; // Return as is if not in expected format
  
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = parseInt(dateString.substring(6, 8), 10);
  
  const date = new Date(`${year}-${month}-${day}`);
  if (isNaN(date.getTime())) return dateString;
  
  const options = { month: "long", day: "numeric" };
  let formattedDate = date.toLocaleDateString("en-US", options);
  
  // Add ordinal suffix
  const suffixes = ["th", "st", "nd", "rd"];
  const relevantDigit = day % 10;
  const suffix = suffixes[(day % 100 - 10) % 10] || suffixes[relevantDigit] || "th";
  
  return formattedDate.replace(/\d+/, day + suffix);
};

const EventCard = ({ name, date, description, eventurl, ...props }) => {
  const direction = useDirection();
  const formattedDate = formatDate(date);

  return (
    <Box
      {...props}
      border={3}
      borderRadius={10}
      borderColor="primary.main"
      sx={{ width: "100%", minWidth: "200px", maxWidth: "500px", height: "480px", overflow: "hidden" }}
    >
      <Box sx={{ mt: "20px", ml: "20px", mr: "20px", maxWidth: "400px" }}>
        <Typography
          variant="body1"
          sx={{ fontSize: direction === "horizontal" ? "2.5rem" : "2rem", whiteSpace: "normal", wordWrap: "break-word" }}
          color="primary"
        >
          {name}
        </Typography>

        <Box sx={{ height: "20px" }} />
        <Typography variant="body1" sx={{ fontSize: "1.5rem", display: "inline", mr: "10px" }} color="primary">
          When:
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "1.5rem", display: "inline", whiteSpace: "normal" }} color="primary">
          {formattedDate}
        </Typography>

        <Box sx={{ height: "20px" }} />
        <Typography variant="body1" sx={{ fontSize: "1.5rem", display: "inline", mr: "10px" }} color="primary">
          What is it:
        </Typography>

        <Typography variant="body1" sx={{ fontSize: "1rem", whiteSpace: "normal", wordWrap: "break-word" }} color="primary">
          {description}
        </Typography>

        <div style={{ flexDirection: "row", display: "flex", justifyContent: "center" }}>
          <AddToCalendarButton eventLink={eventurl} buttonText="RSVP" />
        </div>
      </Box>
    </Box>
  );
};

export default EventCard;
